// import { Link } from "react-router-dom";
// import { useState } from "react";

// const MenuItem = ({ item, depth = 0 }) => {

//   const [open, setOpen] = useState(false);

//   const hasChildren = item.children && item.children.length > 0;

//   return (
//     <li
//       className="menu-item"
//       onMouseEnter={() => setOpen(true)}
//       onMouseLeave={() => setOpen(false)}
//     >

//       {/* If page */}
//       {!hasChildren && (
//         <Link to={item.path}>{item.name}</Link>
//       )}

//       {/* If dropdown */}
//       {hasChildren && (
//         <>
//           <span className="menu-title">
//             {item.name} ▸
//           </span>

//           <ul className={`submenu depth-${depth} ${open ? "show" : ""}`}>
//             {item.children.map((child, index) => (
//               <MenuItem key={index} item={child} depth={depth + 1} />
//             ))}
//           </ul>
//         </>
//       )}

//     </li>
//   );
// };

// export default MenuItem;

import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const MenuItem = ({ item, closeMenu, depth = 0 }) => {

  const [open, setOpen] = useState(false);
  const location = useLocation();


  const hasChildren = item.children && item.children.length > 0;

  const isActive =
    item.path === "/"
      ? location.pathname === "/"
      : item.path && location.pathname.startsWith(item.path);

  return (
    <li
      className={`menu-item ${isActive ? "active" : ""}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >

      {/* NORMAL LINK */}
      {!hasChildren && (
        <Link to={item.path} onClick={closeMenu}>{item.name}</Link>
      )}

      {/* DROPDOWN LINK (FIXED) */}
      {hasChildren && (
        <>
          {/* <Link to={item.path || "#"} className="menu-title"  onClick={closeMenu}>
            {item.name} ▸
          </Link> */}

          <span 
  className="menu-title"
  onClick={() => setOpen(!open)}
>
  {item.name} ▸
</span>

          {/* <ol className={`submenu depth-${depth} ${open ? "show" : ""}`}>
            {item.children.map((child, index) => (
              <MenuItem key={index} item={child} depth={depth + 1}  closeMenu={closeMenu} />
            ))} 

            
        </ol> */}
          
          <ol className={`submenu depth-${depth} ${open ? "show" : ""}`}>

  {/* 🔥 ADD THIS */}
  {item.path && (
    <li>
      <Link to={item.path} onClick={closeMenu}>
        {item.name}
      </Link>
    </li>
  )}

  {item.children.map((child, index) => (
    <MenuItem 
      key={index} 
      item={child} 
      depth={depth + 1} 
      closeMenu={closeMenu} 
    />
  ))}

</ol>
      
        </>
      )}

    </li>
  );
};

export default MenuItem;
